import { keepPreviousData } from "@tanstack/react-query";
import dayjs from "dayjs";

import { StatCard } from "@design-system/StatCard/StatCard";

import { useClientEmployeeAppUsageCountQuery } from "./EmployeeAppCountUsageStat.g";

type Props = {
  clientEmployeeId: string;
  clientId: string;
  dateRange?: [Date | null, Date | null];
};

export const EmployeeAppCountUsageStat = ({
  clientEmployeeId,
  dateRange,
}: Props) => {
  const { data } = useClientEmployeeAppUsageCountQuery(
    {
      employeeId: clientEmployeeId,
      ...(dateRange?.[0] && {
        dateFrom: dayjs(dateRange[0]).format("YYYY-MM-DD"),
      }),
      ...(dateRange?.[1] && {
        dateTo: dayjs(dateRange[1]).format("YYYY-MM-DD"),
      }),
    },
    {
      placeholderData: keepPreviousData,
    }
  );

  const appCount = data?.clientEmployeeApplicationInteractions?.totalCount;

  return (
    <StatCard
      icon="faShapes"
      title="Number of used apps"
      value={(appCount ? appCount : 0).toString()}
    />
  );
};
